module.exports = new __parcel__URL__("fluidpasslogo.39e9225e.png").toString();